const norm = (s) => String(s || '').toLowerCase().replace(/\s+/g, ' ').trim();

// Android Chrome repeats/accumulates final results in continuous mode -> single-shot sessions there
export const continuousOk = !/Android/i.test(navigator.userAgent);

// returns only the genuinely new part of a final transcript (drops repeats and cumulative copies)
export function freshPart(mem, txt, now = Date.now()) {
  const a = norm(mem.last), b = norm(txt);
  if (!b) return '';
  let out = String(txt).trim();
  if (a && now - mem.at < 6000) {
    if (b === a || a.endsWith(b)) return '';
    if (b.startsWith(a)) out = out.slice(String(mem.last).trim().length).trim();
  }
  mem.last = String(txt).trim(); mem.at = now;
  return out;
}

const CMD = {
  de: [['neuer absatz', '\n\n'], ['neue zeile', '\n'], ['fragezeichen', '?'], ['ausrufezeichen', '!'], ['doppelpunkt', ':'], ['komma', ','], ['punkt', '.']],
  sq: [['paragraf i ri', '\n\n'], ['rresht i ri', '\n'], ['pikëpyetje', '?'], ['pikëçuditje', '!'], ['dy pika', ':'], ['pikëpresje', ';'], ['presje', ','], ['pikë', '.']],
  en: [['new paragraph', '\n\n'], ['new line', '\n'], ['question mark', '?'], ['exclamation mark', '!'], ['exclamation point', '!'], ['full stop', '.'], ['period', '.'], ['colon', ':'], ['comma', ',']],
  it: [['nuovo paragrafo', '\n\n'], ['nuova riga', '\n'], ['a capo', '\n'], ['punto interrogativo', '?'], ['punto esclamativo', '!'], ['due punti', ':'], ['virgola', ','], ['punto', '.']],
  es: [['nuevo párrafo', '\n\n'], ['nueva línea', '\n'], ['signo de interrogación', '?'], ['signo de exclamación', '!'], ['dos puntos', ':'], ['coma', ','], ['punto', '.']],
  pt: [['novo parágrafo', '\n\n'], ['nova linha', '\n'], ['ponto de interrogação', '?'], ['ponto de exclamação', '!'], ['dois pontos', ':'], ['vírgula', ','], ['ponto final', '.'], ['ponto', '.']],
  fr: [['nouveau paragraphe', '\n\n'], ['nouvelle ligne', '\n'], ['à la ligne', '\n'], ["point d'interrogation", '?'], ["point d'exclamation", '!'], ['deux-points', ':'], ['deux points', ':'], ['virgule', ','], ['point', '.']],
};
const esc = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&').replace(/'/g, "['’]").replace(/[ -]/g, '[\\s-]+');

// spoken commands ("Punkt", "neue Zeile" …) -> punctuation, tidy spacing and capitals
export function speakPunct(txt, locale = 'de') {
  const list = CMD[String(locale).slice(0, 2)] || CMD.de;
  let s = ` ${txt} `;
  for (const [w, p] of list) s = s.replace(new RegExp(`(^|[\\s,.;:!?])${esc(w)}(?=[\\s,.;:!?]|$)`, 'gi'), (m, pre) => `${pre}\u0000${p}\u0000`);
  s = s.replace(/\s*\u0000([.,?!:])\u0000\s*/g, '$1 ').replace(/[ \t]*\u0000(\n+)\u0000[ \t]*/g, '$1');
  s = s.replace(/([.?!]\s+|\n)(\p{Ll})/gu, (m, a, b) => a + b.toUpperCase());
  return s.replace(/^[ \t]+|[ \t]+$/g, '').replace(/[ \t]{2,}/g, ' ');
}

// joins a new dictated chunk onto existing text without stray spaces before punctuation / after line breaks
export const joinSpeech = (before, chunk) => (!before || /\s$/.test(before) || /^[\n.,?!:]/.test(chunk) ? before + chunk : `${before} ${chunk}`);
